const toSlug = require('@converdy/utils/to-slug')

const RESERVED_SLUGS = ['blog', 'store', 'course', 'site']

export default function validateFunnelSlug (rawSlug = '', usedSlugs = []) {

  let error = false

  const slug =  toSlug(rawSlug).replace(/[^a-zA-Z0-9\-\_]+/g, '')

  /* Check for reserved slugs */ 
  if(RESERVED_SLUGS.includes(slug)) {
    error = `Slug is reserved. Please choose a different slug for your page.` 
  } else if(usedSlugs.includes(slug)) {
    error = `Slug already in use. Please choose a unique slug for your page.`
  } else if(rawSlug.length === 0) {
    error = `Slug can't be blank, the first page in the funnel will be served as root!`
  } else if(rawSlug.includes('/')) {
    error = `Nested directories are not supported.`
  } else if(rawSlug.match(/[^a-zA-Z0-9\-\_]+/g)) {
    error = 'Please enter a valid slug.'
  }
  
  return error

}